<template>
  <div>
    <div class="content">
      <h1>{{$t('addUser.assignCoupons')}}</h1>
    </div>
    <hr />
    <div class="content">
      <div class="row">
        <div class="demiRow" v-if="showGroupOfDiscountList">
          <label>{{$t('groupOfDiscounts.groupOfDiscountsName')}}</label>
          <select
            v-model="groupsOfDiscountSelected"
            @change="showCouponCode = false;isSubmit = false;showErrorGetCoupon = false;"
            :class="{ 'error' : !isDiscountSelected&&isSubmit }"
          >
            <option
              v-for="groupsOfDiscount in groupsOfDiscounts"
              :key="groupsOfDiscount.id"
              :value="groupsOfDiscount"
            >{{groupsOfDiscount['name']}}</option>
          </select>
          <p class="tips">{{$t('assignCoupons.groupOfDiscountSelectWithCouponTips')}}</p>
        </div>
        <div v-else-if="groupsOfDiscounts.length == 0">
          <p>{{$t('assignCoupons.groupOfDiscountNotFound')}}</p>
        </div>
      </div>
      <div class="spacer-10"></div>
      <div class="demiRow" v-if=" Object.keys(groupsOfDiscountSelected).length > 0">
        <label>{{$t('assignCoupons.couponsNumber')}}</label>
        <select v-model="couponNumber">
          <option v-for="value in 10" :key="value">{{value}}</option>
        </select>
      </div>
    </div>
    <hr />
    <div class="content">
      <div class="row">
        <div v-if="showCouponCode" class="row">
          <span class="pStrong">{{$t('assignCoupons.couponAssigned')}}</span>
          <input
            id="codeCoupon"
            type="text"
            v-model="this.couponCode"
            :class="{ 'error':showErrorGetCoupon}"
            readonly
          />
          <span class="tips">{{$t('assignCoupons.transferToYourClient')}}</span>
          <button class="outline" @click="copyClipBoard">{{$t('button.copy')}}</button>
          <a @click="$emit('close')">{{$t('button.close')}}</a>
        </div>
        <button
          v-if="!showCouponCode"
          @click="getCouponByDiscountAndCouponNumber(groupsOfDiscountSelected)"
        >{{$t('button.assign')}}</button>
        <a v-if="!showCouponCode" @click="$emit('close')">{{$t('button.cancel')}}</a>
      </div>
      <div v-if="showErrorGetCoupon" class="row">
        <p class="errorSentence">
          Une erreur est survenue lors de la récupération des coupons, seulement
          <span
            class="pStrong"
          >{{curCouponNumber}} sur les {{couponNumber}} coupons</span> demandés ont été générés
        </p>
        <!-- erreur pas de coupon disponible : modfier le nombre de coupons disponible (lien) -->
      </div>
    </div>
    <!-- POP UPS -->
    <!-- displayed when creating / updating campaign info through server -->
    <WaitBox v-if="showProgressCircleBar" :parMessage="this.ProgressBarMessage" />
  </div>
</template>
<script>
import generalMethods from "@/mixins/generalMethods";
import Coupons from "@/services/Coupons";
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
import WaitBox from "@/mixins/WaitBox";
export default {
  props: ["parCampaignId"],
  mixins: [generalMethods],
  mounted() {
    this.initCoupons(this.parCampaignId);
    this.getDiscountsByCampaignId(this.parCampaignId);
  },
  components: { WaitBox },
  data() {
    return {
      ProgressBarMessage: "Génération de coupons en cours...",
      showProgressCircleBar: false,
      isSubmit: false,
      curCouponNumber: 1,
      couponNumber: 1,
      couponTable: [],
      discounts: [],
      groupsOfDiscounts: [],
      discountSelected: {},
      showCouponCode: false,
      showGroupOfDiscountList: false,
      showErrorGetCoupon: false,
      couponCode: "",
      couponUse: [],
      groupsOfDiscountSelected: {}
    };
  },
  computed: {
    isDiscountSelected: function() {
      return this.groupsOfDiscountSelected["id"];
    }
  },
  methods: {
    initCoupons(campaignId) {
      Coupons.getByCampaignId(campaignId).then(res => {
        if (res.status == 200) {
          this.couponTable = res.data;
        }
      });
    },
    getDiscountType(type) {
      if (type == 0) {
        return "%";
      } else if (type == 1) {
        return "€";
      }
    },
    getDiscountsByCampaignId(campaignId) {
      GroupsOfDiscounts.get(campaignId).then(resGoD => {
        if (resGoD.status == 200) {
          this.groupsOfDiscounts = resGoD.data.filter(x => !x["archived"]);
          if (this.groupsOfDiscounts.length == 1) {
            this.groupsOfDiscountSelected = this.groupsOfDiscounts[0];
          } else if (this.groupsOfDiscounts.length > 1) {
            this.showGroupOfDiscountList = true;
          }
        }
      });
    },
    getCouponByDiscount() {
      this.isSubmit = true;
      if (this.isDiscountSelected) {
        Coupons.getByGroupOfDiscountIdUnusedCoupon(
          this.groupsOfDiscountSelected["id"]
        ).then(
          res => {
            if (res.status == 200) {
              if (res.data) {
                this.couponCode = res.data["value"];
                this.showCouponCode = true;
              } else {
                this.showError = true;
              }
            }
          },
          res => {
            if (res.response.status == 404) this.showError = true;
          }
        );
      }
    },
    getCouponByDiscountAndCouponNumber(groupOfDiscountSelec) {
      this.groupsOfDiscountSelected = groupOfDiscountSelec;
      this.showProgressCircleBar = true;
      this.isSubmit = true;
      var returnArray = [];
      var stringCoup = "";
      this.couponCode = "";
      let self = this;
      function getData(count, idGroupOfDiscount) {
        Coupons.getByGroupOfDiscountIdUnusedCoupon(idGroupOfDiscount).then(
          function(response) {
            returnArray = response.data["value"]
              ? returnArray.concat(response.data)
              : returnArray;
            if (count > 1) return getData(count - 1, idGroupOfDiscount);
            for (var c = 0; c < returnArray.length; c++) {
              stringCoup +=
                c == returnArray.length - 1
                  ? returnArray[c]["value"]
                  : returnArray[c]["value"] + ", ";
            }
            self.curCouponNumber = returnArray.length;
            if (self.curCouponNumber < self.couponNumber) {
              self.showErrorGetCoupon = true;
            }
            self.showProgressCircleBar = false;
            self.showCouponCode = true;
            self.couponCode = stringCoup;
            return returnArray;
          }
        );
      }
      getData(this.couponNumber, this.groupsOfDiscountSelected["id"]);
    },
    copyClipBoard() {
      let testingCodeToCopy = document.querySelector("#codeCoupon");
      testingCodeToCopy.focus();
      testingCodeToCopy.select();
      document.execCommand("copy");
    }
  }
};
</script>